<template>
  <b-card-code title="All lessons " no-body>
    <b-card-body>
      <div class="d-flex justify-content-between flex-wrap">
        <!-- sorting  -->

        <!-- filter -->
        <b-row>
          <b-col md="9">
            <b-form-group label-size="sm" label-for="filterInput" class="mb-0">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Search" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <addNewlesson :id="id" />
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col>
          <b-form-checkbox-group id="checkbox-group-2" v-model="selectedlessons" class="demo-inline-spacing">
            <b-row v-for="(lesson, index) in lessons" :id="lesson.id" :key="lesson.id">
              <b-col md="12">
                <b-form-checkbox :value="lesson">
                  <b-avatar :src="lesson.imageCover" />
                  {{ lesson.title }}
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-form-checkbox-group>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- pagination -->
      <div>
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="prams.limit" first-number last-number
          prev-class="prev-item" next-class="next-item" class="mb-0">
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
    <b-col md="12">
      <b-button variant="success" class="mt-0 mt-md-2 w-100" @click="addlessons()">
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span>Add The lessons</span>
      </b-button>
    </b-col>
  </b-card-code>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
} from "bootstrap-vue";
// import { codeKitchenSink } from "./code";
import lessonsApi from "@/apiServices/lessonsApi";
import deletelesson from "@/views/lessons pages/delete.vue";
import editlesson from "@/views/lessons pages/edit.vue";
import addNewlesson from "@/views/lessons pages/components/add.vue";

export default {
  components: {
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    deletelesson,
    addNewlesson,
    editlesson,
  },
  props: ["id"],

  data() {
    return {
      selectedlessons: [],
      prams: {
        sort: "-createdAt",
        page: 1,
        limit: 100,
        title: "",
      },
      options: ["single_choice", "multi_choice", "true_false"],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      filter: "",
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },

      lessons: [],
    };
  },
  created() {
    // this.getlessons();
  },
  computed: {},
  mounted() {
    // this.totalRows = this.items.length;
  },
  watch: {
    currentPage() {
      this.prams.page = this.currentPage;

      this.getlessons();
    },
    filter() {
      this.prams.page = this.currentPage;
      this.prams.title = this.filter;
      this.getlessons();
    },
  },
  methods: {
    addlessons() {
      console.log("this" + this.selectedlessons);
      try {
        this.$emit("addlessons", this.selectedlessons);
      } catch (e) {
        console.log(e);
      }
    },
    getlessons() {
      if (this.filter == "") {
        delete this.prams.title;
      }
      lessonsApi.getLessons(this.prams).then((response) => {
        this.lessons = [];
        if (response.data) {
          this.lessons = response.data;
          this.currentPage = response.paginationResult?.currentPage;
          this.totalRows =
            response.paginationResult?.numberOfPages * this.prams.limit;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "get All lessons",
              icon: "EditIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      });
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      //   this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
